// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"1433ec72","413":"68ea5a0e","471":"649dee4c","488":"9f286ee6","616":"8066b680","753":"062d84a6"}[chunkId] + ".chunk.js";
};